import React, {useCallback, useMemo, useEffect, useState} from 'react';

import {phones} from 'ultra/configs/countries';
import {ignoreTextFieldKeys} from "ultra/helpers/utils";

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

import {useFormStore} from '../../../../Stores/form';

export default function Phone(props) {
    const {isDisabled, field, value, onChange, onBlur} = props;
    
    const [codeValue, setCodeValue] = useState({code: 'UA', emoji: '🇺🇦', dial_code: '+380'}) // value?.code || 
    const [numberValue, setNumberValue] = useState('') // value?.number || 

    const {formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const [regexpHighlight, setRegexpHighlight] = useState(null)

    const [flagHidden, setFlagHidded] = useState(false)

    const regex = new RegExp('^[0-9]*$');

    const sortedPhones = useMemo(() => {
        return phones.sort(( a, b ) => {
            if (Number(a.dial_code) < Number(b.dial_code)){
              return -1;
            }
            if (Number(a.dial_code) > Number(b.dial_code)){
              return 1;
            }
            return 0;
          })
        
    })
    const [options, setOptions] = useState(sortedPhones)

    useEffect(() => {
        if (codeValue?.dial_code !== value?.code) {
            let code = sortedPhones.find(i => i.dial_code === value?.code);
            if (!code) {
                code = {code: 'UA', emoji: '🇺🇦', dial_code: '+380'};
            }

            setCodeValue(code);
        }
        if (numberValue !== value?.number) setNumberValue(value.number || "");
    }, [value])

    // [...sortedPhones.filter(i => i.dial_code === "+380")]
    // {code: 'UA', emoji: '🇺🇦', dial_code: '+380'}

    // useEffect(() => {
    //     setCodeValue(value?.code || {code: 'UA', emoji: '🇺🇦', dial_code: '+380'});
    //     setNumberValue(value.number || '');
    //     setOptions([...sortedPhones.filter(i => i.dial_code === "+380")]);
    // }, [])

    const onInputChange = useCallback(
        (e) => {
            if (!e?.target?.value) return;

            setFlagHidded(true)
            setOptions([...sortedPhones.filter(i => String(i.dial_code).includes(e?.target?.value))]);
        },
        [options]
    );

    const onNumberChange = (e) => {
        setNumberValue(e.target.value || "")
        onChange({
            number: e.target.value,
            code: codeValue.dial_code
        })
    }

    const onNumberBlur = (e) => {
        onBlur({
            number: e.target.value,
            code: codeValue.dial_code
        })
    }

    const onNumberKeyDownHandler = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 'v') return false;
        if (e.key === 'Enter') return false;

        if (!ignoreTextFieldKeys(e) && !regex.test(e.key)) {
            e.preventDefault();
            setRegexpHighlight("Доступні для вводу символи: числа (0-9)");
        }
        else {
            setRegexpHighlight(null);
        }
    }

    const onCodeKeyDownHandler = (e) => {
        if ((e.ctrlKey || e.metaKey) && e.key === 'v') return false;
        if (e.key === 'Enter') return false;

        if (!ignoreTextFieldKeys(e) && !regex.test(e.key)) {
            e.preventDefault();
            setRegexpHighlight("Доступні для вводу символи: числа (0-9)");
        }
        else {
            setRegexpHighlight(null);
        }
    }

    const onValueChange = (e) => {
        setFlagHidded(false)
        setCodeValue(e)
        onChange({
            number: numberValue,
            code: e.dial_code,
        })
    }

    const onPasteHandler = (e) => {
        const pastedData = (e.clipboardData || window.clipboardData).getData('text');
        if (!regex.test(pastedData)) {
            setRegexpHighlight("Доступні для вводу символи: числа (0-9)");
            e.preventDefault();
        }

        // if (fieldErrorCheck) fieldErrorCheck(e);
    }

    return <div className='MessengerFieldPhoneField'>
            <div className='code'>
                {!flagHidden && <span className={`flags`}>{codeValue?.emoji}</span>}
                <Autocomplete
                    fullWidth
                    disableClearable

                    noOptionsText="Відсутній код"

                    options={options}

                    getOptionLabel={(option) => option?.dial_code || ''}

                    value={codeValue}

                    disabled={isDisabled}

                    onInputChange={onInputChange}

                    onChange={(e, value) => {
                        onValueChange(value)
                    }}

                    isOptionEqualToValue={(option, value) => {
                        return option?.dial_code === value?.dial_code
                    }}

                    renderInput={(params) => <TextField
                        {...params}
                        onKeyDown={onCodeKeyDownHandler}
                        label="Код"
                    />}

                    renderOption={(props, option) => {
                        const {key, ...optionProps} = props;
                        return <Box
                            key={'select_flag_' + option.code} {...optionProps}
                            component="li"
                            className={`CountriesListItem`}
                        >
                            <span className='flags'>
                                {option.emoji}
                            </span>
                            <span className='code'>{option.dial_code}</span>
                        </Box>
                    }}
                />
            </div>

            <div className='text'>
                <TextField
                    className='ContactNumber'
                    fullWidth
                    disabled={isDisabled}
                    value={numberValue}
                    label="Номер"
                    // required

                    error={Boolean(regexpHighlight || showErrorText)}
                    helperText={regexpHighlight || showErrorText}

                    variant="outlined"

                    onKeyDown={onNumberKeyDownHandler}
                    onChange={onNumberChange}
                    onBlur={onNumberBlur}
                    onPaste={onPasteHandler}

                    inputProps={{
                        inputMode: "tel",
                    }}
                />
            </div>
        </div>
}
